import React from 'react';

const Footer = () => {
    return (
        <div className='footer'>
            <p>Fitness Exercises Website.</p>
            <p>Created by <a href='https://github.com/mvrius4' target='_blank' rel='noreferrer'>mvrius</a>.</p>
        </div>
    )
}

export default Footer;